import React from 'react';
import PropTypes from 'prop-types';
import keyBoardKey from 'keyboard-key';
import { defineMessages, injectIntl } from 'react-intl';
import FocusLock from 'react-focus-lock';

import Modal from '../../components/Modal';
import Popup from '../../components/Popup';
import Input from '../../components/Input';
import Icon from '../../components/Icon';

import FilterList from './filter-list';
import CollegeEventsCreateFilterPage from '../CollegeEventsCreateFilter';
import './styles.css';

const messages = defineMessages({
  placeholder: {
    id: 'collegeevents.filters.placeholder',
    defaultMessage: 'Type to search filters...',
  },
});

export class FilterComponent extends React.PureComponent {
  static propTypes = {
    'intl': PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    'viewer': PropTypes.object,
    'selectedFilter': PropTypes.object,
    'onSelectionChange': PropTypes.func.isRequired,
    'id': PropTypes.string,
    'aria-labelledby': PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      isPopupOpen: false,
      openModel: false,
      focusLock: true,
      selectedLocationIndex: -1,
    };
    this.modalTargetNode = undefined;
    this.inputTargetNode = undefined;
    this.inputFilterNode = null;
  }

  componentWillMount = () => {
    this.updateSearchText(this.props);
  };

  componentWillReceiveProps = (nextProps) => {
    this.updateSearchText(nextProps);
  };

  onSearchChange = (e, { searchText }) => {
    searchText = searchText || e.target.value;
    if (searchText === '') {
      this.setState({ searchText, isPopupOpen: false });
      return;
    }
    this.setState({ isPopupOpen: false }, () => {
      this.setState({ searchText, isPopupOpen: true });
    });
  };

  onClosePopup = () => {
    if (this.state.isPopupOpen) {
      this.updateSearchText(this.props);
      this.setState({ isPopupOpen: false, focusLock: true });
    }
  };

  inputRef = (inputFilterNode) => { this.inputFilterNode = inputFilterNode; };

  onSelectionChange = (filter) => {
    this.props.onSelectionChange(filter);
    this.onClosePopup();
  };

  onFilterSaved = (result) => {
    this.closeModel();
    this.props.onSelectionChange(result.data.createCollegeEventFilter.collegeEventFilter);
  };

  newClick = () => {
    this.updateSearchText(this.props);
    this.setState({ openModel: true, isPopupOpen: false, focusLock: true });
  };

  updateSearchText = (props) => {
    if (props.selectedFilter && props.selectedFilter.name) {
      this.setState({ searchText: props.selectedFilter.name });
    } else {
      this.setState({ searchText: '' });
    }
  };

  closeModel = () => {
    this.setState({ openModel: false });
  };

  onDeactivation = () => {
    // Without the zero-timeout, focus will not be applied a/c to focus-loc docs.
    setTimeout(() => {
      if (this.inputTargetNode) { this.inputTargetNode.focus(); }
    }, 0);
  };

  onKeyDownInput = (event) => {
    const keyCode = keyBoardKey.getCode(event);
    if (keyCode === keyBoardKey.ArrowDown && this.state.isPopupOpen) {
      document.querySelector('#eventFilter ul li:nth-child(1) > button').focus();
      setTimeout(() => {
        document.querySelector('#eventFilter ul li:nth-child(1) > button').scrollIntoView();
      }, 50);
      this.setState({ focusLock: false });
    } else if (keyCode === keyBoardKey.Tab) {
      this.setState({ isPopupOpen: false });
    }
  };

  render() {
    const { searchText, isPopupOpen, openModel } = this.state;
    const { viewer: { eventFilters }, intl } = this.props;
    const placeholder = intl.formatMessage(messages.placeholder);
    const filters = eventFilters;

    const popupTrigger = (
      <Input
        ref={(el) => { this.inputTargetNode = el; }}
        icon
        value={searchText}
        styleName="filter-input"
        onChange={this.onSearchChange}
        onKeyDown={this.onKeyDownInput}
      >
        <Icon name="search" />
        <input
          id={this.props.id}
          type="text"
          name="filters-dropdown"
          aria-label={`${this.props['aria-labelledby']} - ${placeholder}`}
          placeholder={placeholder}
          ref={this.inputRef}
        />
      </Input>
    );

    return (
      <div ref={(el) => { this.modalTargetNode = el; }}>
        {popupTrigger}
        <Popup
          id="eventFilter"
          name="eventFilter"
          basic
          pinned
          size="large"
          position="top left"
          open={isPopupOpen}
          onClose={this.onClosePopup}
          styleName="filters-popup"
          context={this.inputFilterNode}
        >
          <Popup.Content>
            <FilterList {...{
              filters,
              searchText,
              onSelectionChange: this.onSelectionChange,
              onNewClick: this.newClick,
              focusLock: this.state.focusLock,
              onClosePopup: this.onClosePopup,
              selectedLocationIndex: this.state.selectedLocationIndex,
              setSelectedLocationIndex: this.setSelectedLocationIndex,
            }}
            />
          </Popup.Content>
        </Popup>
        <Modal style={{ marginTop: 0 }} mountNode={this.modalTargetNode} open={openModel} onClose={this.closeModel}>
          <Modal.Content styleName="filter-modal">
            <FocusLock
              autoFocus
              onDeactivation={this.onDeactivation}
            >
              <CollegeEventsCreateFilterPage onFilterSaved={this.onFilterSaved} onCancel={this.closeModel} />
            </FocusLock>
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

const CollegeEventFilterComponent = injectIntl(FilterComponent);

export default CollegeEventFilterComponent;
